/*
 * Action Types
 */
export enum CurrentModuleTypes {
  SET_CURRENT_MODULE = '@currentModule/SET_CURRENT_MODULE',
}

/*
 * State type
 */
export interface CurrentModuleState {
  readonly currentModuleData: string;
}
